import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../../state/auth.store';
import { DuckMark } from './DuckMark';

/** Clean closing footer — wordmark, the in-page nav anchors, a sign-in / enter-lobby link, and copyright. */
export function LandingFooter(): JSX.Element {
  const authed = useAuthStore((s) => s.tokens !== null);
  return (
    <footer className="border-t border-white/10 px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 sm:flex-row">
        <a href="#top" className="flex items-center gap-2 rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-amber-300/70">
          <DuckMark className="h-6 w-6" />
          <span className="text-sm font-extrabold tracking-tight text-white">Duck Duck Space</span>
        </a>

        <nav aria-label="Footer" className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-white/55">
          <a href="#features" className="rounded outline-none transition hover:text-white focus-visible:ring-2 focus-visible:ring-amber-300/70">Features</a>
          <a href="#how-it-works" className="rounded outline-none transition hover:text-white focus-visible:ring-2 focus-visible:ring-amber-300/70">How it works</a>
          <a href="#gallery" className="rounded outline-none transition hover:text-white focus-visible:ring-2 focus-visible:ring-amber-300/70">Gallery</a>
          <a href="#faq" className="rounded outline-none transition hover:text-white focus-visible:ring-2 focus-visible:ring-amber-300/70">FAQ</a>
          <Link to={authed ? '/lobby' : '/login'} className="rounded outline-none transition hover:text-white focus-visible:ring-2 focus-visible:ring-amber-300/70">{authed ? 'Enter lobby' : 'Sign in'}</Link>
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-7xl text-center text-xs text-white/35 sm:text-left">
        © {new Date().getFullYear()} Duck Duck Space — the MMORPG where people accidentally spend their
        workday because they genuinely enjoy being there.
      </p>
    </footer>
  );
}
